module.exports = __webpack_public_path__ + "55c04f68d5342cc222eef4b763d1dfee.svg";